import { ofType } from "redux-observable";
import { delay, mapTo, take } from "rxjs/operators";
import { TypeActionApp } from "../../../app/actionApp";
import { actionGameTrackingUpdateClientFunnel } from "../../actionGameTracking";
import { IdGameTrackingClientFunnelState } from "../IdGameTrackingClientFunnelState";
export var epicGameTrackingClientFunnelAppConnected = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), take(1), delay(2), mapTo(actionGameTrackingUpdateClientFunnel(IdGameTrackingClientFunnelState.SERVER_CONNECTION_START)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/game-funnel/epics/epicGameTrackingClientFunnelAppConnected.ts
// module id = 1868
// module chunks = 3